import stringFormatter from '@/utils/format/string';
import numberUtils from '@/utils/number.utils';

export default function(value: number | string): string {
  const number: number = Number(value);

  if (window.isNaN(number)) {
    return <string> value;
  }

  let integer: number = Math.floor(number);
  let beautifulNumber = '';

  do {
    const needPad = integer >= 1000;
    const part = integer % 1000;
    const beautifulPart = needPad ? String(part).padStart(3, '0') : part;

    beautifulNumber = `${beautifulPart} ${beautifulNumber}`;
    integer = Math.floor(integer / 1000);
  } while (integer % 1000 > 0);

  beautifulNumber = stringFormatter.trim(beautifulNumber);

  const fraction: number = Math.round(number % 1 * 100);

  if (fraction === 0) {
    return beautifulNumber;
  }

  return `${beautifulNumber}.${String(fraction).padStart(2, '0')}`;
}
